import { render, staticRenderFns } from "./content.vue?vue&type=template&id=5c7ebfec&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=5c7ebfec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ebfec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7ebfec')) {
      api.createRecord('5c7ebfec', component.options)
    } else {
      api.reload('5c7ebfec', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=5c7ebfec&scoped=true&", function () {
      api.rerender('5c7ebfec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/content.vue"
export default component.exports